<template>
    <div class="main-body flex-fill">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "Body",
};
</script>

<style lang="scss" scoped>

$body-radius: 32px;
.main-body {
    background-color: #fff;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: $body-radius $body-radius 0px 0px;
    padding: 32px 24px;
}
</style>
